/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Mailer_MissingInputs */

const en_mail_admin_mailer_missing = /** @type {(inputs: Mail_Admin_Mailer_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mailer is not configured.`)
};

const de_mail_admin_mailer_missing = /** @type {(inputs: Mail_Admin_Mailer_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mailer nicht konfiguriert.`)
};

/**
* | output |
* | --- |
* | "Mailer is not configured." |
*
* @param {Mail_Admin_Mailer_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_mailer_missing = /** @type {((inputs?: Mail_Admin_Mailer_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Mailer_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_mailer_missing(inputs)
	return en_mail_admin_mailer_missing(inputs)
});